import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
// import { getCharity } from 'src/actions/getCharities'
// import { getSCh } from 'src/actions/getselectedCh'
import CharityCard from 'src/components/cards/CharityCard'
import Page from 'src/components/layouts/Page'
import { getCharities, getCharityChoice } from 'src/slices/charity'
import css from './Charities.module.scss'
import EmptyPage from 'src/components/molecules/EmptyPage'

export default function Charities(params) {
	const { permissions } = useSelector(state => state.auth)
	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(getCharities())
		dispatch(getCharityChoice())
	}, [])
	const { charities } = useSelector(state => state.charity)
	const { choice } = useSelector(state => state.charity)

	return (
		<Page>
			{permissions.read.includes('charities') ? (
				<div className={css['cards']}>
					{charities?.map((charity, index) => {
						return (
							<CharityCard
								name={charity?.name}
								id={charity?._id}
								isSelected={charity?._id == choice}
								selected={charity}
								logo={charity?.image}
							/>
						)
					})}
				</div>
			) : (
				<EmptyPage
					title='You don’t have permission to view anything on this page'
					text='Ask your employer for access'
					iconName='fad fa-lock'
				/>
			)}
		</Page>
	)
}
